import React, { useState } from "react";
import { Collapse, NavbarBrand, NavItem, Container } from "reactstrap";
import { MyNav, NavbarDiv, NavLinkDiv, Btn, Img, TogglerBtn } from './TopbarStyle';
import { faShoppingCart, faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Topbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
      <NavbarDiv fixed="top" expand="md">
        {/* We used a container to keep Nav elements align with body divs */}
        <Container> 
          <NavbarBrand href="/"><Img src="/images/navLogo.jpg" alt="Natural Grill dark logo"></Img></NavbarBrand>
          <TogglerBtn onClick={toggle}><FontAwesomeIcon icon={faBars}/> </TogglerBtn>
          <Collapse isOpen={isOpen} navbar>
            <MyNav className="ml-auto" navbar>
              <NavItem>
                <NavLinkDiv href="/">Home</NavLinkDiv>
              </NavItem>
              <NavItem>
                <NavLinkDiv href="/menu">Menu</NavLinkDiv>
              </NavItem>
              <NavItem>
                <NavLinkDiv href="/catering">Catering</NavLinkDiv>
              </NavItem>
              <NavItem>
                <NavLinkDiv href="/contact">Contact</NavLinkDiv>
              </NavItem>
              <NavItem >
                <Btn href="http://www.grubhub.com/r/w/85967/restaurant/564198"><FontAwesomeIcon icon={faShoppingCart}/> Order Online</Btn>
              </NavItem>
            </MyNav>
        </Collapse>
        </Container>
      </NavbarDiv>
  );
};
export default Topbar;
